import { urlEscaped } from '@app/utils/urlEscaped'

import { createApiAction } from '@app/packages/api/utils'
import type { ApiAnnouncementResponse } from '@app/packages/api/v2/types/entities'
import type { ApiDataResponse } from '@app/packages/api/v2/types/misc'
import type { PostAnnouncementResponsesRequest, PutAnnouncementResponsesRequest } from '@app/packages/api/v2/types/params'

export const postAnnouncementResponses = (request: PostAnnouncementResponsesRequest) =>
  createApiAction('postAnnouncementResponses', dispatch =>
    dispatch<ApiDataResponse<ApiAnnouncementResponse>>({ method: 'POST', endpoint: '/api/v2/announcement_responses', body: JSON.stringify(request) })
  )

export const putAnnouncementResponsesById = (response_id: string, request: PutAnnouncementResponsesRequest) =>
  createApiAction('putAnnouncementResponsesById', dispatch =>
    dispatch<ApiDataResponse<ApiAnnouncementResponse>>({
      method: 'PUT',
      endpoint: urlEscaped`/api/v2/announcement_responses/${response_id}`,
      body: JSON.stringify(request),
    })
  )

export const putAnnouncementResponsesByIdCancel = (response_id: string) =>
  createApiAction('putAnnouncementResponsesByIdCancel', dispatch =>
    dispatch<ApiDataResponse<ApiAnnouncementResponse>>({ method: 'PUT', endpoint: urlEscaped`/api/v2/announcement_responses/${response_id}/cancel` })
  )

export const putAnnouncementResponsesByIdDecline = (response_id: string) =>
  createApiAction('putAnnouncementResponsesByIdDecline', dispatch =>
    dispatch<ApiDataResponse<ApiAnnouncementResponse>>({ method: 'PUT', endpoint: urlEscaped`/api/v2/announcement_responses/${response_id}/decline` })
  )
